var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Badge - Suspended",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lock_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#aeb7bc",
    strokeWidth: 1.25,
    d: "M0 0h7.241v8.159H0z",
    "data-name": "Rectangle 155"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 241"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#aeb7bc",
    strokeWidth: 1.25,
    clipPath: "url(#lock_svg__a)",
    "data-name": "Group 240",
    transform: "translate(8.379 7.843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.019 3.774h5.204v3.367H1.019z",
    "data-name": "Rectangle 154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.937 2.703a1.683 1.683 0 113.367 0v1.072H1.937z",
    "data-name": "Path 285"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGRhdGEtbmFtZT0iQmFkZ2UgLSBTdXNwZW5kZWQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PGNsaXBQYXRoIGlkPSJhIj48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNhZWI3YmMiIHN0cm9rZS13aWR0aD0iMS4yNSIgZD0iTTAgMGg3LjI0MXY4LjE1OUgweiIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMTU1Ii8+PC9jbGlwUGF0aD48L2RlZnM+PGcgZGF0YS1uYW1lPSJHcm91cCAyNDEiPjxnIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2FlYjdiYyIgc3Ryb2tlLXdpZHRoPSIxLjI1IiBjbGlwLXBhdGg9InVybCgjYSkiIGRhdGEtbmFtZT0iR3JvdXAgMjQwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4LjM3OSA3Ljg0MykiPjxwYXRoIGQ9Ik0xLjAxOSAzLjc3NGg1LjIwNHYzLjM2N0gxLjAxOXoiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDE1NCIvPjxwYXRoIGQ9Ik0xLjkzNyAyLjcwM2ExLjY4MyAxLjY4MyAwIDEgMSAzLjM2NyAwdjEuMDcySDEuOTM3WiIgZGF0YS1uYW1lPSJQYXRoIDI4NSIvPjwvZz48L2c+PC9zdmc+";
export { SvgLock as ReactComponent };